import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import { setupListeners } from "@reduxjs/toolkit/query";

import { authAPI, riccAPI } from "@/service/APIService";
import authSlice from "./authSlice";
import productSlice from "./productSlice";
import ownersSlice from "./ownersSlice";
import adminSlice from "./adminSlice";
import profileSlice from "./profileSlice";
import commonSlice from "./commonSlice";

import "@/service/AdminService";
import "@/service/ProfileService";
import "@/service/OwnerService";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [authAPI.reducerPath, riccAPI.reducerPath], // don't persist RTK query cache
};

const combinedReducers = combineReducers({
  [authAPI.reducerPath]: authAPI.reducer,
  [riccAPI.reducerPath]: riccAPI.reducer,
  authReducer: authSlice,
  productsReducer: productSlice,
  ownersReducer: ownersSlice,
  adminReducer: adminSlice,
  profileReducer: profileSlice,
  commonReducer: commonSlice,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined; //
  }
  return combinedReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// --- configure store ---
const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.MODE !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(authAPI.middleware, riccAPI.middleware),
});

setupListeners(store.dispatch);

// --- configure persistor ---
export const persistor = persistStore(store);

// --- helper thunk for logout ---
export const logout = () => (dispatch) => {
  dispatch({ type: "LOGOUT" });
  persistor.purge();
};

export default store;
